import { FC, useId } from 'react'
import { LEGAL_LINKS } from 'shared/config/legal-links'
import styles from './styles.module.scss'

type Props = {
    variant: 'light' | 'dark'
    consentChecked: boolean
    onConsentChange: (checked: boolean) => void
}

const linkProps = {
    target: '_blank' as const,
    rel: 'noopener noreferrer' as const,
}

export const LegalFormDisclaimer: FC<Props> = ({
    variant,
    consentChecked,
    onConsentChange,
}) => {
    const consentId = useId()
    const rowClass =
        variant === 'light' ? `${styles.row} ${styles.rowLight}` : `${styles.row} ${styles.rowDark}`

    return (
        <div className={rowClass}>
            <input
                id={consentId}
                type="checkbox"
                className={styles.checkbox}
                checked={consentChecked}
                onChange={(event) => onConsentChange(event.target.checked)}
            />
            <label htmlFor={consentId} className={styles.labelText}>
                Даю свое{' '}
                <a href={LEGAL_LINKS.personalData} {...linkProps} onClick={(event) => event.stopPropagation()}>
                    согласие на обработку своих персональных данных
                </a>
                , а также подтверждаю, что ознакомлен с{' '}
                <a href={LEGAL_LINKS.privacy} {...linkProps} onClick={(event) => event.stopPropagation()}>
                    Политикой в отношении обработки персональных данных
                </a>
                .
            </label>
        </div>
    )
}
